try {
    document.addEventListener('DOMContentLoaded', function() {
        require('./init')
    })
} catch (e) {
    console.log(e)
}
require('./wellimport/app')
require('./widget-types/csb-chart/index')
